export default class OutputSettingSelector {
  static getOutputSettings = state =>
    state.outputSettings.entities.outputSettings;
}
